export default function adjustContentUrls(html, baseURL) {
    return html.replace(/\/wp-content\//g, `/wp-content/`);
}
  